import { useFiltersStore } from '@entities/dating/stores/useFiltersStore';

import { type Account } from '@services/AccountService';

import { useAccountStore } from './useAccountStore';

export const hydrateSearchAges = ({ features, search }: Account) => {
  const { isSearchAgesHydrationSpent, spendSearchAgesHydration } =
    useAccountStore.getState();

  if (isSearchAgesHydrationSpent) return;

  spendSearchAgesHydration();

  if (!features.matchmaker) return;

  if (search.age_from === null && search.age_to === null) return;

  const { filters, setFilters } = useFiltersStore.getState();
  const isLocalAgeDefault =
    !filters.age || (filters.age.from === null && filters.age.to === null);

  if (!isLocalAgeDefault) return;

  setFilters({
    ...filters,
    age: { from: search.age_from, to: search.age_to },
  });
};
